<template>
  <v-app>
    <v-app-bar
      color="primary"
      elevation="0"
      height="110px"
      max-height="110px"
      class="d-none d-md-block"
    >
      <header-base class="p-0" />
    </v-app-bar>
    <v-main>
      <SnackBar/>
      <Loading class="mt-10" v-show="isLoading"/>
      <router-view v-show="!isLoading"/>
    </v-main>
  </v-app>
</template>

<script>
import HeaderBase from "@/components/HeaderBase.vue";
import SnackBar from '@/components/SnackBar.vue';
import Loading from '@/components/GeneralLoading.vue';
import { mapState } from 'vuex';
export default {
  name: "AppVue",
  components: { HeaderBase, SnackBar, Loading },
  computed: {
    ...mapState(['isLoading']) //Para verificar el cambio del estado y mostrar el componente
  },
  metaInfo: {
    title: "Idiomas",
    titleTemplate: "Idiomas",
  },
  created() {
    // Para detectar si se muestra el responsive o no
    const handleSize = () => {
      if (window.innerWidth < 768) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    };
    handleSize();
    window.addEventListener("resize", handleSize);
  },
};
</script>

<style>
.footer {
  position: relative;
  bottom: 0;
  width: 100%;
  background-color: #B0BEC5;
  color: black;
  text-align: center;
  padding: 10px 0;
}
</style>